import { render, staticRenderFns } from "./history.vue?vue&type=template&id=45a9f958"
import script from "./history.ts?vue&type=script&lang=ts&external"
export * from "./history.ts?vue&type=script&lang=ts&external"
import style0 from "./history.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45a9f958')) {
      api.createRecord('45a9f958', component.options)
    } else {
      api.reload('45a9f958', component.options)
    }
    module.hot.accept("./history.vue?vue&type=template&id=45a9f958", function () {
      api.rerender('45a9f958', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/details-page/history/history.vue"
export default component.exports